
export const hexToRgb = (hex, alpha) => {
    if (!hex || !hex.includes('#')) {
        return `rgba(0, 0, 0, ${alpha})`;
    }

    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;

    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

/**
 Add a CSS style class to the given element.  Other CSS classes applied to
 the element will remain intact.  If the elment already has the specified class,
 no change will occur.
 */
export function addStyleClass(elm, cssClassName) {
    let cname = String(elm.className);
    let blocks = cname.split(" ");
    let found = false;

    for (let i = 0; i < blocks.length; i++) {
        if (blocks[i] == cssClassName)
            found = true;
    }

    if (!found) {
        elm.className = cname + " " + cssClassName;
    }
}

/**
 Remove a CSS style class from the given element. Other CSS classes applied to
 the element will remain intact.  If the elment does not have the specified class,
 no change will occur.
 */
export function removeStyleClass(elm, cssClassName) {
    let blocks = String(elm.className).split(" ");
    let res = "";
    let begin = false;

    for (let i = 0; i < blocks.length; i++) {
        if (blocks[i] != cssClassName) {
            if (!begin)
                begin = true;
            else
                res += " ";

            res += blocks[i];
        }
    }

    elm.className = res;
}

/**Determine if the specified element currently has the given CSS class*/
export function hasStyleClass(elm, cssClassName) {
    let cn = ' ' + String(elm.className) + ' ';
    return cn.indexOf(' ' + cssClassName + ' ') != -1;
}

export function isColorDark(hex) {
    if (hex == null || hex === "") {
        hex = '#F5F5F5';
    }

    let red = 0, blue = 0, green = 0;
    if (hex.length === 4) { // 3 digits
        red = "0x" + hex[1] + hex[1];
        green = "0x" + hex[2] + hex[2];
        blue = "0x" + hex[3] + hex[3];
    } else if (hex.length === 7) { // 6 digits
        red = "0x" + hex[1] + hex[2];
        green = "0x" + hex[3] + hex[4];
        blue = "0x" + hex[5] + hex[6];
    }
    const luminance = (0.2126 * red) + (0.7152 * green) + (0.0722 * blue);
    return luminance < 128;
}

export function darken(hex, darkenFactor) {
    if (hex == null || hex === "") {
        hex = '#F5F5F5';
    }

    // Remove the '#' character if present
    hex = hex.replace('#', '');

    // Parse the hex color components
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    r = Math.floor(r * darkenFactor);
    g = Math.floor(g * darkenFactor);
    b = Math.floor(b * darkenFactor);

    // Ensure values stay within valid range (0-255)
    r = (r < 0) ? 0 : ((r > 255) ? 255 : r);
    g = (g < 0) ? 0 : ((g > 255) ? 255 : g);
    b = (b < 0) ? 0 : ((b > 255) ? 255 : b);

    // Convert RGB components back to hex
    return '#' + ('00' + r.toString(16)).slice(-2) +
        ('00' + g.toString(16)).slice(-2) +
        ('00' + b.toString(16)).slice(-2);
}

export function getAssociatedColorById(colorId) {
    if (!colorId) {
        return null;
    }
    for (let i = 0; i < Colors.eventColors.length; i++) {
        const eventColorData = Colors.eventColors[i];
        if (eventColorData.id === colorId) {
            return eventColorData.colorKey;
        }
    }
    return null;
}

export function getTextColorByBackgroundColor(backgroundColorOverride) {
    return isColorDark(backgroundColorOverride) ? Colors.NightModeText : Colors.Black
}

export function getBackgroundColorOfClass(className) {
    const tempEl = document.createElement('div');
    tempEl.className = className;
    document.body.appendChild(tempEl);
    const rgbValue = window.getComputedStyle(tempEl).backgroundColor;
    document.body.removeChild(tempEl);
    return rgbToHex(rgbValue);
}

export function rgbToHex(rgb) {
    const result = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
    const r = parseInt(result[1], 10).toString(16).padStart(2, '0');
    const g = parseInt(result[2], 10).toString(16).padStart(2, '0');
    const b = parseInt(result[3], 10).toString(16).padStart(2, '0');
    return `#${r}${g}${b}`.toUpperCase();
}

export function getAlternateColor(hex) {
    hex = hex.replace(/^#/, '');
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);
    r = 255 - r;
    g = 255 - g;
    b = 255 - b;
    r = r.toString(16).padStart(2, '0');
    g = g.toString(16).padStart(2, '0');
    b = b.toString(16).padStart(2, '0');
    return darken(`#${r}${g}${b}`.toUpperCase(), 0.8);
}